<ng-container *transloco="let t; read: 'reports'">
<div id="selectRating" class="rounded-lg  modal-body">
  <div mat-dialog-title>
    <h3>{{ classroomName ? t('viewStudentByClass.titleInClassroom', { classroom: classroomName }) : t('viewStudentByClass.title') }}</h3>
  </div>
  @if (canSelectAll) {
    <div class="mt-2 ml-2">
      <drdp-btn
        color="outline"
        (click)="selectAllStudents()"
        additionalClasses="text-sm"
        >{{ t('viewStudentByClass.selectAll') }}</drdp-btn
        >
      </div>
    }
    <div mat-dialog-content>
      <drdp-container>
        <div class="w-full">
          <drdp-add-edit-table [dataSource]="dataSource" [columns]="tableColumns"
            (toggleSwitchActionItem)="onToggleSwitchActionItem($event)">
          </drdp-add-edit-table>
        </div>
        <mat-paginator class="mb-12" [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize" [length]="totalData">
        </mat-paginator>
      </drdp-container>
    </div>
    <div mat-dialog-actions class="flex justify-end align-bottom">
      <div class="flex justify-end align-bottom">
        <drdp-btn color="cancel" class="mr-2" mat-dialog-close>{{ 'common.cancel' | transloco }}</drdp-btn>
        <drdp-btn type="button" (click)="selectStudents()" [disabled]="!isStudentSelected()">{{ t('viewStudentByClass.confirm') }}</drdp-btn>
      </div>
    </div>
  </div>
</ng-container>
